<div
  *ngIf="consent.bannerVisible$ | async"
  class="cookie-consent__banner shadow-lg"
  role="region"
  [attr.aria-label]="'COOKIE_CONSENT.TITLE' | translate"
>
  <div class="container-fluid d-flex flex-column flex-md-row align-items-md-center gap-3 py-3">
    <div class="flex-grow-1">
      <h2 class="h6 fw-bold mb-1">{{ 'COOKIE_CONSENT.TITLE' | translate }}</h2>
      <p class="mb-0 small">{{ 'COOKIE_CONSENT.DESCRIPTION' | translate }}</p>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn v-btn-outline-primary btn-sm"
        data-test="cc-customize"
        (click)="openSettings()"
      >
        {{ 'COOKIE_CONSENT.CUSTOMIZE' | translate }}
      </button>
      <button
        type="button"
        class="btn v-btn-primary btn-sm"
        data-test="cc-reject-all"
        (click)="consent.rejectAll()"
      >
        {{ 'COOKIE_CONSENT.REJECT_ALL' | translate }}
      </button>
      <button
        type="button"
        class="btn v-btn-primary btn-sm"
        data-test="cc-accept-all"
        (click)="consent.acceptAll()"
      >
        {{ 'COOKIE_CONSENT.ACCEPT_ALL' | translate }}
      </button>
    </div>
  </div>
</div>

<div
  *ngIf="consent.settingsVisible$ | async"
  class="cookie-consent__backdrop"
  (click)="consent.closeSettings()"
></div>

<div
  *ngIf="consent.settingsVisible$ | async"
  #modalEl
  class="cookie-consent__modal card shadow-lg"
  role="dialog"
  aria-modal="true"
  tabindex="-1"
  [attr.aria-label]="'COOKIE_CONSENT.SETTINGS_TITLE' | translate"
>
  <div class="card-header d-flex align-items-center justify-content-between">
    <h2 class="h6 fw-bold mb-0">
      {{ 'COOKIE_CONSENT.SETTINGS_TITLE' | translate }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.aria-label]="'COOKIE_CONSENT.CLOSE' | translate"
      (click)="consent.closeSettings()"
    ></button>
  </div>
  <div class="card-body cookie-consent__modal-body">
    <p class="small">{{ 'COOKIE_CONSENT.SETTINGS_DESCRIPTION' | translate }}</p>

    <div *ngFor="let row of categories" class="border rounded p-3 mb-2">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div>
          <h3 class="h6 fw-bold mb-1">
            {{ 'COOKIE_CONSENT.CATEGORIES.' + row.key.toUpperCase() + '.TITLE' | translate }}
          </h3>
          <p class="mb-1 small">
            {{ 'COOKIE_CONSENT.CATEGORIES.' + row.key.toUpperCase() + '.DESCRIPTION' | translate }}
          </p>
          <button
            *ngIf="row.cookies.length"
            type="button"
            class="btn btn-link btn-sm p-0"
            [attr.aria-expanded]="!!expanded[row.key]"
            (click)="toggleDetails(row.key)"
          >
            {{ 'COOKIE_CONSENT.VIEW_COOKIES' | translate }} ({{ row.cookies.length }})
          </button>
        </div>
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [attr.data-test]="'cc-toggle-' + row.key"
            [id]="'cc-toggle-' + row.key"
            [checked]="row.locked || draft[row.key]"
            [disabled]="row.locked"
            (click)="onRowToggleClick(row)"
          />
          <label class="visually-hidden" [for]="'cc-toggle-' + row.key">
            {{ 'COOKIE_CONSENT.CATEGORIES.' + row.key.toUpperCase() + '.TITLE' | translate }}
          </label>
        </div>
      </div>

      <div *ngIf="expanded[row.key]" class="table-responsive mt-2">
        <table class="table table-sm small mb-0">
          <thead>
            <tr>
              <th scope="col">{{ 'COOKIE_CONSENT.TABLE.NAME' | translate }}</th>
              <th scope="col">{{ 'COOKIE_CONSENT.TABLE.PROVIDER' | translate }}</th>
              <th scope="col">{{ 'COOKIE_CONSENT.TABLE.PURPOSE' | translate }}</th>
              <th scope="col">{{ 'COOKIE_CONSENT.TABLE.DURATION' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cookie of row.cookies">
              <td><code>{{ cookie.name }}</code></td>
              <td>{{ cookie.provider }}</td>
              <td>{{ cookie.purposeKey | translate }}</td>
              <td>{{ cookie.duration }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex flex-wrap justify-content-end gap-2">
    <button
      type="button"
      class="btn v-btn-primary btn-sm"
      (click)="consent.rejectAll()"
    >
      {{ 'COOKIE_CONSENT.REJECT_ALL' | translate }}
    </button>
    <button
      type="button"
      class="btn v-btn-outline-primary btn-sm"
      data-test="cc-save"
      (click)="saveDraft()"
    >
      {{ 'COOKIE_CONSENT.SAVE' | translate }}
    </button>
    <button
      type="button"
      class="btn v-btn-primary btn-sm"
      (click)="consent.acceptAll()"
    >
      {{ 'COOKIE_CONSENT.ACCEPT_ALL' | translate }}
    </button>
  </div>
</div>

<button
  *ngIf="(consent.consent$ | async) && !(consent.settingsVisible$ | async)"
  type="button"
  class="cookie-consent__reopen btn btn-light border shadow-sm"
  data-test="cc-reopen"
  [attr.aria-label]="'COOKIE_CONSENT.REOPEN' | translate"
  [title]="'COOKIE_CONSENT.REOPEN' | translate"
  (click)="openSettings()"
>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
    <circle cx="8.5" cy="10.5" r="0.5" /><circle cx="12.5" cy="15.5" r="0.5" /><circle cx="15" cy="9" r="0.5" />
  </svg>
</button>
